// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Filtro_AplicafiltrosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * @phpstan-type FiltroFranquia object{FranquiaID: int|string, FuncionariosIDs?: list<string>}
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Filtro_AplicafiltrosResponseDados {
Franquias: object
DataInicio: string
DataFim: string
UsuarioID?: string
}

export type Filtro_AplicafiltrosResponse = ApiResponse<Filtro_AplicafiltrosResponseDados>;

registerResponseContract('Filtro_AplicafiltrosResponse', {
  Franquias:  { type: 'object',  required: true },
  DataInicio: { type: 'string',  required: true },
  DataFim:    { type: 'string',  required: true },
  UsuarioID:  { type: 'string',  required: false },
})
